import { Text } from '@kl/components-v6';
import styled from 'styled-components';

export const MainContainer = styled.main`
    display: flex;
    background: var(--bg--base);
    margin: 0 auto;
    width: 100%;
    flex-grow: 1;
    padding-bottom: 42px;
`;

export const StyledKSCLogo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;

    @media (max-width: 768px) {
        margin: 0 auto;
    }
`;

export const StyledLogoText = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledText = styled(Text)<{
    lineHeight?: string;
}>`
    line-height: ${({ lineHeight }) => lineHeight || '1'};
`;

export const StyledTitleContainer = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;
